import isEmpty from 'lodash/isEmpty';
import { useQuery, UseQueryResult } from 'react-query';
import { WIDGET_ID, WidgetMetricDto } from '../../../services/dtos/riskProducts/widgetMetric.dto';
import { fetchWidgetMetrics } from '../../../services/riskProducts/riskProducts.service';
import { queryKeys } from '../../queryKeyFactory';

const validate = (widgetMetrics: Record<WIDGET_ID, WidgetMetricDto[]>) => {
  Object.values(WIDGET_ID).forEach((widgetId) => {
    if (isEmpty(widgetMetrics[widgetId])) {
      throw new Error('Empty widget metrics');
    }
  });
};

const transformMetric = ({ id: metricId, name: metricName }: WidgetMetricDto): WidgetMetricDto => {
  let id = metricId;
  let name = metricName;
  switch (id) {
    case 'credit_risk_level': {
      id = 'crl';
      break;
    }
    case 'credit_risk_trend_6m': {
      id = 'crt-6m';
      break;
    }
    case 'cqs_trend_1y': {
      id = 'cqs';
      name = 'CQS Trend 1Y';
      break;
    }
    case 'cqs_outlook': {
      id = 'cqs';
      break;
    }
    case 'fas': {
      name = 'Fallen Angel Score';
      break;
    }
    case 'acr': {
      name = 'ACR Tier';
      break;
    }
    default:
      break;
  }
  return { id, name };
};

const useFetchWidgetMetrics = (): UseQueryResult<Record<WIDGET_ID, WidgetMetricDto[]>> => {
  return useQuery<Record<WIDGET_ID, WidgetMetricDto[]>, Error>(
    queryKeys.fetchRiskProducts.dashboard.widgetMetrics,
    async () => {
      const response = await fetchWidgetMetrics();
      const result = response.reduce((acc, current) => {
        acc[current.widgetId] = current.metrics.map((metric) => transformMetric(metric));
        return acc;
      }, {} as Record<WIDGET_ID, WidgetMetricDto[]>);
      validate(result);
      return result;
    }
  );
};

export default useFetchWidgetMetrics;
